import styled from 'styled-components';

import {
  ActionButtonWithConfirmation,
  breakpoints,
  theme,
} from '@notino/react-styleguide';

export const StoreWrapper = styled.div`
  padding: 1.25rem 0;
  :not(:last-child) {
    border-bottom: solid 1px ${theme.color.border.disabled};
  }
  :first-child {
    padding-top: 0;
  }
`;
export const ModalContentWrapper = styled.div`
  max-height: 50vh;
  overflow-y: auto;
  margin-bottom: 1rem;
`;

export const CenterWrapper = styled.div`
  padding-top: 2.8125rem;
  display: flex;
  justify-content: center;
`;

export const StyledActionButtonWithConfirmation = styled(
  ActionButtonWithConfirmation
)`
  @media (min-width: ${breakpoints.sm}) {
    width: auto;
    margin: auto;
    display: block;
  }
`;
